import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actionTypes from '../../store/actions/action-types';
import Switch from '../../components/Switch/Switch';
import classNames from 'classnames';

import { ReactComponent as DesktopIcon } from '../../../../../icons/dpit-desktop-solid.svg';
import { ReactComponent as MobileIcon } from '../../../../../icons/dpit-mobile-alt-solid.svg';
import { ReactComponent as MobileMenuIcon } from '../../../../../icons/dp-bars-solid.svg';
import { ReactComponent as TargetIcon } from '../../../../../icons/dp-cross-hairs-target.svg';
import { ReactComponent as ArrowDownIcon } from '../../../../../icons/dpit-select_arrow-down.svg';
import { ReactComponent as ArrowLeftIcon } from '../../../../../icons/dp-arrow-left-solid.svg';
import { ReactComponent as TrashIcon } from '../../../../../icons/dpit-trash-alt-regular.svg';
import { ReactComponent as SquarePlusIcon } from '../../../../../icons/dpit-square-plus-regular.svg';

import './dpit-step-edit.scss';
import './dpit-step-edit-item.scss';
import { RESPONSIVE_MODE } from '../../../../modules/core/constants';
import { CustomDropdownIndicator, StyleOfSelect } from '../../consts/DpitSelectCustomization';

import Select from '../../components/Select/Select';
import Button from '../../components/Button/Button';
import TextareaAutosize from 'react-textarea-autosize';
import { StepMetaDataContainerWithTransition } from '../StepMetaDataContainer/StepMetaDataContainer';
import InfoIcon from '../../components/InfoIcon/InfoIcon';
import { setTippyContentReact } from './../../react-utils';
import { MultiItemBoxWithTransition } from '../MultiItemBox/MultiItemBox';
import { isTouchDevice } from '../../../../modules/dpitUtilsPublic';
import TargetTypeBox from '../../components/TargetTypeBox/TargetTypeBox';
import TargetIndicator from '../../components/TargetIndicator/TargetIndicator';
import { ContainerWithTransition } from '../Container/Container';



const i18n = window.dpIntroTourPublicConfig.i18n;
class StepEdit extends Component {

	constructor(props) {
		super(props);
		this.selectPositionValueMap = {};
		this.props.positionConfig.options.forEach(option => {
			this.selectPositionValueMap[option.value] = option;
		});
		this.selectHighLightValueMap = {};
		this.props.highlightConfig.options.forEach(option => {
			this.selectHighLightValueMap[option.value] = option;
		});

		this.alertTextsProOnly = {
			'mobileView': i18n.mobile_view_pro_only,
			'mobileMenu': i18n.mobile_menu_pro_only,
			'shortCode': i18n.short_code_pro_only
		};
	}

	onSelectTargetClick = () => {
		if (this.props.onTargetSelectionStarted) {
			this.props.onTargetSelectionStarted();
		}
	};

	onSelectMobileMenuTargetClick = () => {
		if (this.props.onTargetSelectionStarted) {
			this.props.onTargetSelectionStarted(RESPONSIVE_MODE.mobileMenu);
		}
	};

	onSelectMobileTargetClick = () => {
		if (this.props.onTargetSelectionStarted) {
			this.props.onTargetSelectionStarted(RESPONSIVE_MODE.mobile);
		}
	};

	onPositionChange = (position) => {
		this.props.setCurrentStepChange('position', position.value);
	};

	onHighlightModeChange = (highlightOption) => {
		this.props.setCurrentStepChange('highlight', highlightOption.value);
	};

	onAdvancedStepParamChanged = (id, val, advParamName = '') => {
		this.props.setCurrentStepChange(id, val, advParamName);
	};

	onIntroTextChange = (event) => {
		this.props.setCurrentStepChange('intro', event.target.value);
	};

	onSignalTargetTypeClick = (type) => {
		if (!this.props.isPRO) {
			if (confirm(this.alertTextsProOnly[type] + ' ' + i18n.would_you_like_to_check_it)) {
				window.open(this.props.proFeaturesLink, '_blank');
			}
		}
	};

	getTargetTypeValues() {

		let wideScreen = this.props.selector
			? this.props.selector
			: i18n.no_target_selected;
		if (this.props.skip_on_big_screen === '1') wideScreen = i18n.step_skip_wide;

		let mobileBaseVal = i18n.not_overridden_wide;
		if (!this.props.isPRO) mobileBaseVal += ('\n' + i18n.skip_step_wide_mob_pro_only);
		let mobile = this.props.alt_mobile_selector
			? this.props.alt_mobile_selector
			: (this.props.selector
				? mobileBaseVal
				: i18n.no_target_selected
			);
		if (this.props.skip_on_mobile === '1') mobile = i18n.step_skip_mobile;

		let mobileMenu = this.props.alt_mobile_selector && this.props.is_in_mobile_menu === '1'
			? i18n.target_has_mob_men_alt
			: i18n.target_does_not_have_mob_men_alt;
		if (!this.props.isPRO) mobileMenu += (' ' + i18n.mob_menu_only_pro);

		return {
			wideScreen,
			mobile,
			mobileMenu
		};
	}

	getEditorControlsTitles() {
		return {
			target: this.props.element ? i18n.change_target_el : i18n.select_target_el,
			redirect: this.props.isPRO ? i18n.redirect_to_url : i18n.multi_page_only_pro_prompt
		};
	}

	render() {
		if (!this.props.core) return null;

		const editorControlsTitles = this.getEditorControlsTitles();
		const targetTypeValues = this.getTargetTypeValues();

		const targetMultiItemBox = (
			<MultiItemBoxWithTransition
				classBEMRoot='dpit-multi-item-box'
				className='dpit-step-edit__target-ctrl'
				openDisabled={!this.props.isPRO}
				active={true}
				externalState={true}
				isOpened={this.props.isTargetDetailOpened}
				onOpenChange={this.props.updateTargetDetailOpened}
				onMenuSurroundingClick={() => {
					this.props.updateTargetDetailOpened(!this.props.isTargetDetailOpened);
				}}
			>
				<Button
					classBEMRoot='dpit-step-edit__button'
					className={classNames({
						'dpit-step-edit__button--semi-trans-bg': !this.props.element,
						'dpit-step-edit__button--has-mob-selector': this.props.alt_mobile_selector,
						'dpit-step-edit__button--target': true,
						'dpit-pulse-infinite-light-2s': !this.props.element
					})}
					disabled={this.props.isInteractionDetailOpened}
					active={true}
					onClick={() => {
						if (!isTouchDevice() || !this.props.isPRO) this.onSelectTargetClick();
					}}
					title={editorControlsTitles.target}
				/>

				<ContainerWithTransition
					classBEMRoot='dpit-box-sub-item'
					active={true}
					className={classNames({
						'dpit-step-edit__sub-button': true,
						'dpit-step-edit__target-type-box': true,
						'dpit-step-edit__target-type-box--no-target': !this.props.selector,
						'dpit-step-edit__target-type-box--skipped': this.props.skip_on_big_screen === '1',
					})}
				>
					<TargetTypeBox
						classBEMRoot="dpit-target-type-box"
						targetTypeTitle={i18n.wide_screen}
						mainIcon={<DesktopIcon />}
						targetIcon={<TargetIcon />}
						ctaLabel={this.props.selector ? i18n.change_target : i18n.set_target}
						animateTargetIcon={true}
						skip={this.props.skip_on_big_screen}
						valueText={targetTypeValues.wideScreen}
						onSkipChange={val => this.props.onSkipChange('skip_on_big_screen', val)}
						targetSelector={this.props.selector}
						onCtaClick={this.onSelectTargetClick}
						onClearClick={this.props.onResetTargetClick}
						noTargetMsg={i18n.no_target_selected}
						i18n={this.props.i18n}
					/>
				</ContainerWithTransition>

				<ContainerWithTransition
					classBEMRoot='dpit-box-sub-item'
					active={true}
					className={classNames({
						'dpit-button-exit--slower-opacity': true,
						'dpit-step-edit__sub-button': true,
						'dpit-step-edit__target-type-box': true,
						'dpit-step-edit__target-type-box--no-target': !this.props.alt_mobile_selector,
						'dpit-step-edit__target-type-box--skipped': this.props.skip_on_mobile === '1',

					})}
				>
					<TargetTypeBox
						classBEMRoot="dpit-target-type-box"
						targetTypeTitle={i18n.mobile}
						mainTitle={this.props.alt_mobile_selector ? i18n.change_target_mob : i18n.override_target_mob}
						mainIcon={this.props.is_in_mobile_menu === '1' ? <MobileMenuIcon /> : <MobileIcon />}
						targetIcon={<MobileMenuIcon />}
						skip={this.props.skip_on_mobile}
						valueText={targetTypeValues.mobile}
						cta2Label={i18n.other}
						ctaLabel={i18n.in_mob_menu}
						onSkipChange={val => this.props.onSkipChange('skip_on_mobile', val)}
						targetSelector={this.props.alt_mobile_selector}
						onCta2Click={this.onSelectMobileTargetClick}
						onCtaClick={this.onSelectMobileMenuTargetClick}
						onClearClick={() => this.props.is_in_mobile_menu === '1'
							? this.props.onResetMobileTargetClick(RESPONSIVE_MODE.mobileMenu)
							: this.props.onResetMobileTargetClick(RESPONSIVE_MODE.mobile)
						}
						noTargetMsg={this.props.selector ? i18n.not_overridden_wide : i18n.no_target_selected}
						i18n={this.props.i18n}
					/>
				</ContainerWithTransition>

			</MultiItemBoxWithTransition>
		);


		const targetSignalIcons = (
			<div className={classNames({
				'dpit-step-edit__signals': true,
				'dpit-step-edit__signals--disabled': this.props.isTargetDetailOpened && this.props.isPRO
			})}>
				<TargetIndicator
					classBEMRoot="dpit-target-indicator"
					small={true}
					scaleOnHover={true}
					inactive={!this.props.selector}
					skip={this.props.skip_on_big_screen}
					title={targetTypeValues.wideScreen}
					onClick={this.onSelectTargetClick}
				>
					<DesktopIcon />
				</TargetIndicator>
				<TargetIndicator
					classBEMRoot="dpit-target-indicator"
					small={true}
					scaleOnHover={true}
					inactive={!this.props.alt_mobile_selector}
					skip={this.props.skip_on_mobile}
					title={targetTypeValues.mobile}
					onClick={this.props.isPRO
						? this.onSelectMobileTargetClick
						: () => this.onSignalTargetTypeClick('mobileView')
					}
				>
					<MobileIcon />
				</TargetIndicator>
				<TargetIndicator
					classBEMRoot="dpit-target-indicator"
					small={true}
					scaleOnHover={true}
					inactive={!this.props.alt_mobile_selector || this.props.is_in_mobile_menu !== '1'}
					skip={this.props.skip_on_mobile}
					title={targetTypeValues.targetUIValueMobileMenu}
					onClick={this.props.isPRO
						? this.onSelectMobileMenuTargetClick
						: () => this.onSignalTargetTypeClick('mobileMenu')
					}
				>
					<MobileMenuIcon />
				</TargetIndicator>

			</div>
		);



		const interactionAdvancedDisabled = this.props.isInteractionDetailOpened
			|| this.props.isTargetDetailOpened
			|| !this.props.element
			|| this.props.isTargetDetailOpened;
		const interactionUi = (
			<React.Fragment>
				<Switch
					className={classNames({
						'dpit-step-edit__switch': true,
						'dpit-switch--disabled': !this.props.element || this.props.isTargetDetailOpened
					})}
					options={[{
						displayName: i18n.ON,
						value: '1',
					}, {
						displayName: i18n.OFF,
						value: '0',
					}]}
					selectedOption={this.props.enable_interaction?.val
						?? this.props.stepDefinitions?.enable_interaction?.def ?? '0'
					}
					onSelectOption={val => {
						this.onAdvancedStepParamChanged('enable_interaction', { ...this.props?.enable_interaction ?? {}, val: val });
					}}
				/>
				<MultiItemBoxWithTransition
					classBEMRoot='dpit-multi-item-box'
					className='dpit-multi-item-box--slide-down dpit-step-edit-item--interaction'
					openDisabled={false}
					active={this.props.enable_interaction?.val == 1}
					externalState={true}
					isOpened={this.props.isInteractionDetailOpened}
					onOpenChange={(isOpened) => {
						if (!isOpened || !interactionAdvancedDisabled) {
							this.props.updateInteractionDetailOpened(isOpened);
						}
					}}
				>
					<ArrowDownIcon
						className={classNames({
							'dpit-step-edit__arrow-down': true,
							'dpit-step-edit__arrow-down--hidden': interactionAdvancedDisabled
						})}

					/>
					<StepMetaDataContainerWithTransition
						classBEMRoot='dpit-step-meta-data'
						active={true}
						val={this.props.enable_interaction}
						definition={this.props.stepDefinitions?.enable_interaction?.ext}
						onChange={(advParamName, newVal) => this.onAdvancedStepParamChanged('enable_interaction', newVal, advParamName)}
					>
						<ArrowDownIcon
							className={classNames({
								'dpit-step-edit__arrow-down': true,
								'dpit-step-edit__arrow-down--up': true,
								'dpit-step-edit__arrow-down--hidden': !this.props.isInteractionDetailOpened,
								'dpit-step-edit__arrow-down--l': true,
								'dpit-step-meta-data__arrow-up': true

							})}
							onClick={() => this.props.updateInteractionDetailOpened(false)}
						/>
					</StepMetaDataContainerWithTransition>

				</MultiItemBoxWithTransition>


			</React.Fragment >
		);



		return (
			<div className="dpit-step-edit">
				<div className='dpit-step-edit__ctrls'>

					<div className={classNames({
						'dpit-step-edit-item': true,
						'dpit-step-edit-item--disabled': this.props.isInteractionDetailOpened,
					})} title={editorControlsTitles.target}>
						<div className='dpit-step-edit-item__label'>{i18n.target}</div>
						{targetMultiItemBox}
						{targetSignalIcons}
					</div>

					<div className={classNames({
						'dpit-step-edit-item': true,
						'dpit-step-edit-item--disabled': !this.props.element
							|| this.props.isTargetDetailOpened
							|| this.props.core.isDummyMode()
					})} title={i18n.allow_interact}>

						<div className='dpit-step-edit-item__label'>{i18n.interaction}</div>
						{interactionUi}
					</div>

					<div
						className={classNames({
							'dpit-step-edit-item': true,
							'dpit-step-edit-item--disabled': !this.props.element
								|| this.props.isTargetDetailOpened
								|| this.props.isInteractionDetailOpened
								|| this.props.core.isDummyMode()
						})}
						title={!this.props.element ? i18n.set_target_first : i18n.tooltip_pref_pos}>

						<div className='dpit-step-edit-item__label'>{i18n.position}</div>
						<Select
							className={classNames({
								'dpit-select': true,
								'dpit-step-edit-item__select': true
							})}
							classBEMRoot='dpit-select'
							options={this.props.positionConfig.options}
							value={this.selectPositionValueMap[this.props.position || '']}
							placeholder={this.props.positionConfig.options[this.props.positionConfig.defIdx].label}
							theme={StyleOfSelect}
							components={{ DropdownIndicator: CustomDropdownIndicator }}
							onChange={this.onPositionChange}
						/>
					</div>

					<div className={classNames({
						'dpit-step-edit-item': true,
						'dpit-step-edit-item--disabled': this.props.isTargetDetailOpened || this.props.isInteractionDetailOpened,
					})} title={editorControlsTitles.redirect}>
						<div className='dpit-step-edit-item__label'>{i18n.URL}</div>
						<Button
							classBEMRoot='dpit-step-edit__button'
							className={classNames({
								'dpit-step-edit__button--url': true
							})}
							disabled={!this.props.isPRO
								|| this.props.isTargetDetailOpened
								|| this.props.isInteractionDetailOpened
							}
							active={true}
							onClick={this.props.onUrlRedirectClick}
							title={editorControlsTitles.redirect}
						/>
					</div>
				</div>

				<div className='dpit-step-edit__wrap'>
					<div className={classNames({
						'dpit-step-edit-item': true,
						'dpit-step-edit-item--ta-wrap': true,
						'dpit-step-edit-item--on-light-bg': true,
						'dpit-step-edit-item--disabled': this.props.isTargetDetailOpened || this.props.isInteractionDetailOpened
					})}
					>
						<label className='dpit-step-edit-item__label dpit-step-edit-item__label--ta'>
							{i18n.edit_tour_tip_text}
							<span
								onClick={this.props.isPRO
									? null
									: () => this.onSignalTargetTypeClick('shortCode')}
								className={classNames({ 'dpit-pro-only': !this.props.isPRO })}>{' / ' + i18n.short_code}
							</span>
							<InfoIcon
								classBEMRoot="dpit-step-edit-item__label__icon"
								className="dpit-info-icon dpit-info-icon--builder-step-edit"
								infoText={this.props.isPRO
									? i18n.new_short_code_needs_reload
									: this.alertTextsProOnly['shortCode']}
							/>
						</label>

						<TextareaAutosize
							className={classNames({
								'dpit-step-edit__content': true,
								'dpit-scrollbar dpit-scrollbar--y': true,
								'dpit-step-edit__content--higher-on-mobile': this.props.isTargetDetailOpened || this.props.isInteractionDetailOpened
							})}
							value={this.props.intro || ''}
							placeholder={'Enter tour tip text'}
							minRows={4}
							maxRows={10}
							onClick={this.props.onContentEditClick}
						/>
					</div>

					<div className='dpit-step-edit__ctrls-2'>
						<div className={classNames({
							'dpit-step-edit-item--in-column': true,
							'dpit-step-edit-item--on-light-bg': true,
							'dpit-step-edit-item--disabled': !this.props.element
								|| this.props.core.isDummyMode()
								|| this.props.isTargetDetailOpened
								|| this.props.isInteractionDetailOpened
						})} title={!this.props.element ? i18n.set_target_first : i18n.tooltip_pref_highlight}>
							<div className={classNames({
								'dpit-step-edit-item__label': true,
								'dpit-step-edit-item__label--hb': true,
							})}>
								{this.props.stepDefinitions.highlight.title}
								<InfoIcon
									classBEMRoot="dpit-step-edit-item__label__icon"
									className="dpit-info-icon dpit-info-icon--builder-step-edit"
									infoText={setTippyContentReact(this.props.stepDefinitions.highlight.hint)}
								/>
							</div>
							<Select
								className={classNames({
									'dpit-select': true,
									'dpit-step-edit-item__select': true,
									'dpit-select--disabled': !this.props.element
								})}
								classBEMRoot='dpit-select'
								options={this.props.highlightConfig.options}
								value={this.selectHighLightValueMap[this.props.highlight || '']}
								placeholder={this.props.highlightConfig.options[this.props.highlightConfig.defIdx].label}
								theme={StyleOfSelect}
								components={{ DropdownIndicator: CustomDropdownIndicator }}
								onChange={this.onHighlightModeChange}
							/>
						</div>
					</div>
				</div>
				<div className='dpit-step-edit__navig'>
					<Button
						classBEMRoot='dpit-step-edit__navig__button'
						className='dpit-step-edit__navig__button--back'
						title={i18n.go_to_prev_step}
						active={true}
						onClick={this.props.onPreviousStepButtonClick}
						disabled={this.props.step <= 1}
						hovered={this.props.isNavigButtonBackHovered}
						onMouseEnter={() => { this.props.core.actualizeNavigButtonHoverState(false, true); }}
						onMouseLeave={() => { this.props.core.actualizeNavigButtonHoverState(false, false); }}
					>
						<ArrowLeftIcon
							className={classNames({
								'dpit-step-edit__navig__btn-ico': true,
								'dpit-step-edit__navig__btn-ico--left': true
							})}
						/>
					</Button>

					<Button
						classBEMRoot='dpit-step-edit__navig__button'
						className='dpit-step-edit__navig__button--next'
						title={i18n.go_to_next_step}
						active={true}
						onClick={this.props.onNextStepButtonClick}
						disabled={this.props.step >= this.props.stepCount}
						hovered={this.props.isNavigButtonNextHovered}
						onMouseEnter={() => { this.props.core.actualizeNavigButtonHoverState(true, true); }}
						onMouseLeave={() => { this.props.core.actualizeNavigButtonHoverState(true, false); }}
					>
						<ArrowLeftIcon
							className={classNames({
								'dpit-step-edit__navig__btn-ico': true,
								'dpit-step-edit__navig__btn-ico--right': true
							})}
						/>
					</Button>

					<Button
						classBEMRoot='dpit-step-edit__navig__button'
						className='dpit-step-edit__navig__button--add'
						title={i18n.add_after_hint}
						active={true}
						onClick={this.props.addNewStepAfterFce}
					>
						<SquarePlusIcon
							className={classNames({
								'dpit-step-edit__navig__btn-ico': true,
								'dpit-step-edit__navig__btn-ico--remove': true
							})}
						/>
					</Button>

					<Button
						classBEMRoot='dpit-step-edit__navig__button'
						className='dpit-step-edit__navig__button--remove'
						title={i18n.remove_current_step}
						active={true}
						onClick={this.props.onRemoveButtonClick}
					>
						<TrashIcon
							className={classNames({
								'dpit-step-edit__navig__btn-ico': true,
							})}
						/>
					</Button>
				</div>
			</div >
		);

	}
}
const mapStateToProps = (state) => ({
	intro: state.introStep.intro,
	position: state.introStep.position,
	highlight: state.introStep.highlight,
	url: state.introStep.url,
	enable_interaction: state.introStep.enable_interaction,
	element: state.introStep.element,
	selector: state.introStep.selector,
	skip_on_big_screen: state.introStep.skip_on_big_screen,
	skip_on_mobile: state.introStep.skip_on_mobile,
	is_in_mobile_menu: state.introStep.is_in_mobile_menu,
	alt_mobile_selector: state.introStep.alt_mobile_selector,
	step: state.introStep.step,
	stepCount: state.app.stepCount,
	isNewStep: state.app.isNewStep,
	isNavigButtonNextHovered: state.app.isNavigButtonNextHovered,
	isNavigButtonBackHovered: state.app.isNavigButtonBackHovered,
	isTargetDetailOpened: state.app.isTargetDetailOpened,
	isInteractionDetailOpened: state.app.isInteractionDetailOpened
});

const mapDispatchToProps = dispatch => {
	return {
		updateTargetDetailOpened: (isOpened) => dispatch({ type: actionTypes.UPDATE_TARGET_EDIT_DETAIL_OPENED, isOpened: isOpened }),
		updateInteractionDetailOpened: (isOpened) => dispatch({ type: actionTypes.UPDATE_INTERACTION_EDIT_DETAIL_OPENED, isOpened: isOpened })
	};
};


export default connect(mapStateToProps, mapDispatchToProps)(StepEdit);
